import api from './authService';

export const startContainer = async (id) => {
    const response = await api.post(`/container/start/${id}`);
    return response.data;
};

export const stopContainer = async (id) => {
    const response = await api.post(`/container/stop/${id}`);
    return response.data;
};

export const restartContainer = async (id) => {
    const response = await api.post(`/container/restart/${id}`);
    return response.data;
};

export const getContainerLogs = async (id) => {
    const response = await api.get(`/container/logs/${id}`);
    return response.data;
};

export const updateAllContainers = async () => {
    const response = await api.post('/container/update', {});
    return response.data;
};
